export default {
    meta: {
        title: '打包价设置',
        isShowNav: true,
        activeMenu: '/publicationPrice',
        crumbs: {
            path: ['/publicationPrice'],
            name: ['刊例价管理'],
        },
    },
};
